import '.ao{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.j4{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.aq{justify-content:center;}.ssr-plugin'
import '.ag{align-items:flex-start;}.ssr-plugin'
import '.ey{padding:2rem;}.ssr-plugin'
import '.e2{background:var(--palette-white);}.ssr-plugin'
import '.b7{overflow:hidden;}.ssr-plugin'
import '.bj{position:absolute;}.ssr-plugin'
import '.fm{top:50%;}.ssr-plugin'
import '.fq{right:1rem;}.ssr-plugin'
import '.fn{transform:translateY(-50%);}.ssr-plugin'
import '.lo{width:120px;}.ssr-plugin'
import '.lp{height:120px;}.ssr-plugin'
import '.lq{z-index:0;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.e6{z-index:1;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.lr{max-width:calc(100% - 140px);}.ssr-plugin'
import '.ls{font-size:4rem;}.ssr-plugin'
import '.cn{font-weight:700;}.ssr-plugin'
import '.lf{line-height:100%;}.ssr-plugin'
import '.ig{margin:0px;}.ssr-plugin'
import '.a3{color:var(--brand-secondary);}.ssr-plugin'
import '.a4{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ao n j4 a b aq ag ey e2 b7"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bj fm fq fn lo lp lq a t aq"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ao e6 a b ag u lr"
      >
        <div className="ls cn lf ig a3 a4"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
